/* eslint-disable no-console */
import {InfoCircleOutlined} from '@ant-design/icons';
import {Divider, Flex} from 'antd';
import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import GapAnalysisBg from '../../../../assets/skeleton/GapAnalysisBg.png';
import BlockAccessPage from '../../../../components/BlockAccess/BlockAccessPage';
import PageContent from '../../../../components/PageContent/PageContent';
import Year from '../../../../shared/Year';
import {accessModule} from '../../../../store/companyStore/companyDetailsStore';
import {checkCurrentYearOrBelow} from '../../../../utils/commonFunctions';
// import {yearSelect} from '../../../../utils/FormUtils/yearSelect';
import {shouldBlockModuleAccess} from '../../../../utils/SubscriptionHelper';

import GapAnalysisSection from './GapAnalysisSection';

const GapAnalysisPage: React.FC = () => {
  // const firstYear = yearSelect();

  const [searchParam, setSearchParams] = useSearchParams();
  const [selectedYear, setSelectedYear] = useState('');
  console.log('selectedYear:', selectedYear);
  useEffect(() => {
    const currentYear = checkCurrentYearOrBelow(
      searchParam.get('selectedYear')
    );
    setSelectedYear(currentYear);
    searchParam.set('selectedYear', currentYear);
    setSearchParams(searchParam);
  }, []);

  return (
    <PageContent>
      {searchParam.get('selectedYear') && (
        <Flex vertical={false} align="center" justify="space-between">
          <Flex align="center" justify="space-around" gap={5}>
            <div
              style={{
                font: 'normal normal 700 16px Montserrat',
                letterSpacing: '0.56px',
                color: '#282A3A'
              }}
            >
              Gap Analysis
            </div>
            <Flex
              style={{
                padding: '6px 12px',
                backgroundColor: '#F3F4F8',
                borderRadius: '100px',
                font: 'normal normal 500 14px Montserrat',
                height: '32px'
              }}
              gap={5}
            >
              <InfoCircleOutlined />
              Based on BRSR Framework
            </Flex>
          </Flex>
          {shouldBlockModuleAccess(
            accessModule.Reporting_And_ESG,
            accessModule.gap_analytics
          ) ? null : (
            <Year
              setSelectedYear={setSelectedYear}
              isESG
              colSpan={24}
              noBottomMargin
            />
          )}
        </Flex>
      )}
      <Divider
        orientationMargin="0"
        className="divider"
        style={{margin: '12px 0px 12px 0px'}}
      />
      {shouldBlockModuleAccess(
        accessModule.Reporting_And_ESG,
        accessModule.gap_analytics
      ) ? (
        <div style={{height: 800}}>
          <BlockAccessPage backgroundImage={GapAnalysisBg} />
        </div>
      ) : (
        <GapAnalysisSection />
      )}
    </PageContent>
  );
};

export default GapAnalysisPage;
